import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Profiles from "./pages/Profiles";
import Login from "./pages/login";
import NewLogin from "./pages/newLogin";
import Signup from "./pages/Signup";
import Search from "./pages/Search";
import Client from "./pages/Client";
import SharedProfiles from "./pages/sharedProfiles";
import ClientView from "./pages/ClientView";
import ViewProfile from "./pages/ViewProfile";
import ClientViewProfile from "./pages/ClientViewProfile";
import Profile from "./pages/ProfileCard";
import Calendly from "./pages/Calendly";
import CalendlyReschedule from "./pages/CalendlyReschedule";
import CalendlyCancel from "./pages/CalendlyCancel";
// import NotFound from "./pages/DisabledLink";
import store from "./store";
import BoardInfo from "./pages/BoardInfo";
import { PrivateRoute } from "./routes/privateRoutes";
import RequestSignUp from "./pages/RequestSignUp";
import Form from "./pages/form";
import MeetingDetials from "./pages/MeetingDetials";
import AddMeeting from "./pages/AddMeeting";
import BoardDetails from "./pages/BoardDetails";
import Board2 from "./pages/Board2";
import ClientBoard from "./pages/ClientBoard";
import AddCandidates from "./pages/AddCandidates";
import candidateAdded from "./pages/CandidateAdded";
import Notifications from "./pages/NotificationOnPhone";
import NotFound from "./pages/404.js";
import CandidateAdded from "./pages/CandidateAdded";
import RedirectionPage from "./pages/redirectionPage";
import ClientLogin from "./pages/clientLogin";
import AddProspect from "./pages/addProspect";
import CsvUpload from "./pages/csvUpload";
import CandidateTable from "./pages/candidateTable";

function App() {
  return (
    <>
      <Provider store={store}>
        <Router>
          <Routes>
            <Route
              exact
              path="/"
              element={
                <PrivateRoute>
                  <Profiles />
                </PrivateRoute>
              }
            />
            <Route path="/login" element={<NewLogin />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/sharedProfiles" element={<SharedProfiles />} />
            <Route path="/form" element={<Form />} />
            <Route
              exact
              path="/clientBoard"
              element={<PrivateRoute>{<ClientBoard />}</PrivateRoute>}
            />
             <Route
              exact
              path="/clientLogin"
              element={<ClientLogin />}
            />
            <Route
              exact
              path="/addProspect"
              element={<PrivateRoute>{<AddProspect />}</PrivateRoute>}
            />
             <Route
              exact
              path="/fileUpload"
              element={<PrivateRoute>{<CsvUpload />}</PrivateRoute>}
            />
            <Route
              exact
              path="/board"
              element={<PrivateRoute>{<Board2 />}</PrivateRoute>}
            />
            <Route
              path="/details"
              element={<PrivateRoute>{<BoardInfo />}</PrivateRoute>}
            />
            <Route
              path="/interviewSchedule"
              element={<PrivateRoute>{<Calendly />}</PrivateRoute>}
            />
            <Route
              path="/interviewReSchedule"
              element={<PrivateRoute>{<CalendlyReschedule />}</PrivateRoute>}
            />
            <Route
              path="/interviewCancel"
              element={<PrivateRoute>{<CalendlyCancel />}</PrivateRoute>}
            />
            <Route
              exact
              path="/search"
              element={<PrivateRoute>{<Search />}</PrivateRoute>}
            />
            <Route
              path="/client"
              element={<PrivateRoute>{<Client />}</PrivateRoute>}
            />
            <Route
              path="/clientview"
              element={<PrivateRoute>{<ClientView />}</PrivateRoute>}
            />
            <Route
              path="/viewprofile"
              element={
                // <PrivateRoute>
                <ViewProfile />
                // </PrivateRoute>
              }
            />
            <Route
              path="/clientViewProfile"
              element={
                // <PrivateRoute>
                <ClientViewProfile />
                // </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                // <PrivateRoute>
                <Profile />
                // </PrivateRoute>
              }
            />

            <Route path="/requestSignup" element={<RequestSignUp />} />
            <Route path="/boardDetails" element={
              <PrivateRoute>
                {<BoardDetails />}
              </PrivateRoute>
              } />

            <Route path="/redirect" element={
              <PrivateRoute>
                {<RedirectionPage />}
              </PrivateRoute>
              } />
            
            <Route path="/candidates" element={<PrivateRoute>{<CandidateTable />}</PrivateRoute>} />
            <Route path="/addCandidates" element={<PrivateRoute>{<AddCandidates />}</PrivateRoute>} />
            <Route path="/candidateAdded" element={<CandidateAdded />} />
            <Route path="/meetingDetails" element={<MeetingDetials />} />
            <Route path="/addMeeting" element={<AddMeeting />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/notfound" element={<NotFound />} />
          </Routes>
        </Router>
      </Provider>
    </>
  );
}

export default App;
